import axios from 'axios';
import cache, { del as delCache } from '@/helpers/cache';
import { Order } from '@/models/order';
import PackageHelper, { Package } from '@/models/package';
import { Coupon } from '@/models/coupon';
import { Pagination } from '@/models/pagination';
import { View } from '@/models/view';
import { DataReq } from '@/components/Pivot/views/view';
import { SaveDataFile } from '@/helpers/SaveDataFile';
import { Bundle } from '@/models/bundle';
import { Permission } from '@/models/permission';
import { ServiceMatrix, ServiceMatrixUser } from '@/models/serviceMatrix';

// const BASE_URL = 'https://api.calibration.hearxgroup.com';
// const token = 'TTRcKm5PGzgUhHwnrwR7qaxxdBzy4RMAVTd6vh9PAxcjXLSb';

// auth http client using firebase token
const axAuth = axios.create({
  // baseURL: BASE_URL,
  baseURL: process.env.VUE_APP_API_BASE_URL,
  // withCredentials: true, // not sure why, but it works if not set

  headers: {
    'Accept': 'application/json, text/plain, */*',
    'Content-Type': 'application/json',
  },
});

const dataOnly = (v: any) => v.data;

export interface PivotReq {
  filter: any;
}

const api = {
  http: axAuth,

  setToken(token: string) {
    this.http.defaults.headers.authorization = 'token ' + token;
  },

  async getAllDevices() {
    const key = `/admin/calibration/v1/find_device`;
    return dataOnly(
      await cache(key, 60 * 5, () => this.http.get(`/admin/calibration/v1/find_device?imei`)),
    ).devices as Device[];
  },
};

// api.setToken(token);

export default api;

export interface Device {
  id: string;
  imei: string;
  data: string;
  account_id?: string;
}
